
import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({ providedIn: 'root' })
export class SystemIdService {
  private key = 'system_id';

  getSystemId(): string {
    let id = localStorage.getItem(this.key);
    if (!id) {
      id = uuidv4();
      localStorage.setItem(this.key, id);
    }
    return id;
  }
}